import * as React from "react";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { NavLink as RouterLink } from "react-router-dom";
import { sidebarlinks } from "../utils/sidebarlinks";

function ListItemLink(props) {
  const { icon, primary, to, handleDrawerClose } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined}
          style={({ isActive }) => {
            return {
              textDecoration: "none",
              color: isActive ? "DeepPink" : "inherit",
            };
          }}
        />;
      }),
    [to]
  );

  return (
    <li>
      <ListItemButton component={renderLink} onClick={handleDrawerClose}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItemButton>
      <Divider />
    </li>
  );
}

ListItemLink.propTypes = {
  icon: PropTypes.element,
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default function MenuListItems({ handleDrawerClose }) {
  return (
    <Box>
      <List aria-label="industries list">
        <ListItemLink
          key="home"
          to="/"
          primary="Dashboard"
          // onClick={handleDrawerClose}
          handleDrawerClose={handleDrawerClose}
        />
        {/* <ListItemLink
          key="companies"
          to="/companies"
          primary="Public Companies DB"
          handleDrawerClose={handleDrawerClose}
        /> */}
        {sidebarlinks.map((item) => (
          <ListItemLink
            key={`${item.title}`}
            to={`/${item.route}`}
            primary={`${item.title}`}
            handleDrawerClose={handleDrawerClose}
          />
        ))}
      </List>
    </Box>
  );
}
